import { apiService } from "./api.service";
import { IPortalUser } from "../models/interfaces/authentication/portal-user.model.interface";
import { IResponseModel } from "../models/interfaces/response.model.interface";

class UserDataService {

    private static serviceInstance: UserDataService;

    private constructor() { }

    public static get instance() {
        // Do you need arguments? Make it a regular method instead.
        return this.serviceInstance || (this.serviceInstance = new this());
    }

    public async getUsers()
  : Promise<IResponseModel<IPortalUser[]>> {
        return apiService.get(`/api/v1/user`)
        .then((response) => {
                const result = response.data as IResponseModel<IPortalUser[]>;
                return result;
            })
        .catch((error) => {
                const result: IResponseModel<IPortalUser[]> = {
                    success: false,
                    result: []
                };
                return result;
            });
    }

    public async getUser(
      id: number
    ): Promise<IPortalUser | null> {
        return apiService.get(`/api/v1/user/${id}`)
        .then((response) => {
                const result = response.data.result as IPortalUser;
                return result;
            })
        .catch((error) => {
          return null;
        });
    }

    public async authorise(
      id: number
    ): Promise<boolean> {
        return apiService.post(`/api/auth/v1/registration/user/${id}/authorise`)
        .then((response) => {
                const result = response.data.success;
                return result;
            })
        .catch((error) => {
          return false;
        });
    }

    public async block(
      id: number,
      block: boolean
    ): Promise<boolean> {
        return apiService.post(`/api/v1/user/${id}/block`, {block})
        .then((response) => {
                const result = response.data.success;
                return result;
            })
        .catch((error) => {
          return false;
        });
    }

    public async revenueAccess(
      id: number,
      revenueAccess: boolean
    ): Promise<boolean> {
        return apiService.post(`/api/v1/user/${id}/revenue`, {revenueAccess})
        .then((response) => {
                const result = response.data.success;
                return result;
            })
        .catch((error) => {
          return false;
        });
    }
}

// export a singleton instance in the global namespace
export const userDataService = UserDataService.instance;
